import { Controller } from "@hotwired/stimulus";

// Controls desktop-only toggle for aside#layout-menu
export default class extends Controller {
  connect() {
    this.storageKey = "desktopMenuCollapsed";
    this.mql = window.matchMedia("(min-width: 992px)");
    this._onMqChange = this._onMqChange.bind(this);
    if (this.mql.addEventListener)
      this.mql.addEventListener("change", this._onMqChange);
    else if (this.mql.addListener) this.mql.addListener(this._onMqChange);

    // Sync initial state
    this.sync();

    // Listen to Helpers toggle events to keep in sync when Helpers runs
    window.addEventListener("layouttoggle", () => this.sync());
  }

  disconnect() {
    if (!this.mql) return;
    if (this.mql.removeEventListener)
      this.mql.removeEventListener("change", this._onMqChange);
    else if (this.mql.removeListener) this.mql.removeListener(this._onMqChange);
  }

  toggle(event) {
    if (event && event.preventDefault) event.preventDefault();
    if (!this._isDesktop()) return;

    const menuEl = document.getElementById("layout-menu");
    if (!menuEl) return;

    const brandEl = document.querySelector(".app-brand-second");

    const isHidden = menuEl.classList.contains("d-none");
    if (isHidden) {
      menuEl.classList.remove("d-none");
      menuEl.classList.add("d-block");

      brandEl.classList.remove("d-flex");
      brandEl.classList.add("d-none");

      try {
        localStorage.setItem(this.storageKey, "false");
      } catch (err) {}
      this._adjustLayout(false);
    } else {
      menuEl.classList.add("d-none");
      menuEl.classList.remove("d-block");

      brandEl.classList.remove("d-none");
      brandEl.classList.add("d-flex");
      try {
        localStorage.setItem(this.storageKey, "true");
      } catch (err) {}
      this._adjustLayout(true);
    }
  }

  sync() {
    try {
      const menuEl = document.getElementById("layout-menu");
      const brandEl = document.querySelector(".app-brand-second");
      if (!menuEl) return;
      if (!this._isDesktop()) {
        // Let Helpers manage mobile; remove our classes to avoid interfering
        menuEl.classList.remove("d-none");
        menuEl.classList.remove("d-block");
        brandEl.classList.remove("d-flex");
        brandEl.classList.remove("d-none");
        return;
      }

      // desktop: decide based on localStorage if present, otherwise try Helpers
      let collapsed = null;
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (raw === "true") collapsed = true;
        else if (raw === "false") collapsed = false;
      } catch (err) {}

      if (collapsed === null) {
        try {
          if (
            window.Helpers &&
            typeof window.Helpers.isCollapsed === "function"
          ) {
            collapsed = window.Helpers.isCollapsed();
          }
        } catch (err) {}
      }

      if (collapsed) {
        menuEl.classList.add("d-none");
        menuEl.classList.remove("d-block");
        brandEl.classList.remove("d-none");
        brandEl.classList.add("d-flex");
        this._adjustLayout(true);
      } else {
        menuEl.classList.remove("d-none");
        menuEl.classList.add("d-block");
        brandEl.classList.remove("d-flex");
        brandEl.classList.add("d-none");
        this._adjustLayout(false);
      }
    } catch (err) {}
  }

  _adjustLayout(hidden) {
    try {
      const page = document.querySelector(".layout-page");
      if (!page) return;
      if (hidden) {
        // remove left padding so content fills full width
        page.style.paddingLeft = "0";
      } else {
        // restore to stylesheet-controlled value
        page.style.paddingLeft = "";
      }
    } catch (err) {}
  }

  _onMqChange() {
    // When breakpoint changes, re-sync
    this.sync();
  }

  _isDesktop() {
    try {
      return this.mql
        ? this.mql.matches
        : window.matchMedia("(min-width: 992px)").matches;
    } catch (err) {
      return false;
    }
  }
}
